import Heading from "../../SubComponents/Heading/Heading";
import { ExpData } from "../../Utils/localdata";

import "./ExperienceStyle.css";
import { useState, useEffect } from "react";

export default function Experience() {
  const [state, setState] = useState(ExpData[0]);
  const [show, setShow] = useState(true);
  const [roleInfo, setRoleInfo] = useState(ExpData[0].role);
  const [skillSet, setSkillSet] = useState(ExpData[0].skillsUsed);
  const [gradientState, setGradientState] = useState(ExpData[0].gradient);

  const clickHandle = (id) => {
    setState(ExpData[id]);
    setGradientState(ExpData[id].gradient);
    setShow(true);
    setSkillSet(ExpData[id].skillsUsed);
    setRoleInfo(ExpData[id].role);
  };
  useEffect(() => {
    setTimeout(function () {
      setShow(false);
    }, 1000);
  }, [show]);

  return (
    <div className="experience-div" id="experience" data-aos="fade-up">
      <Heading index={2}>Experience</Heading>
      <div className="exp-text">
        In this section, you'll find a summary of my experience, including{" "}
        <span className="blue-text">
          my current position and previous roles
        </span>{" "}
        , as well as my key
        <span className="blue-text">
          {" "}
          achievements and responsibilities.
        </span>{" "}
      </div>
      <div className="exp-details">
        <div className="exp-title-container border gradient-border ">
          {ExpData.map((item) => {
            const { id } = item;

            return (
              <div
                className="exp-title"
                key={id}
                onClick={(e) => {
                  clickHandle(id);
                }}
              >
                <div
                  className={`exp-title-text gradient-${gradientState}`}
                  key={id}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
        </div>

        <div className="exp-info-container">
          <div
            className={`exp-info gradient-${gradientState} ${
              show ? "show-div" : ""
            }`}
          >
            <div className="exp-role-info">
              <div className="role-name">
                {roleInfo[0]}
                <span className="role-sub-div"> @{state.name}</span>
              </div>
              <div className="role-duration">{roleInfo[1]}</div>
            </div>
            <ul className="exp-info-list">
              {state.summary.map((item, id) => {
                return <li key={id}>{item}</li>;
              })}
            </ul>
            <div className="btn-div">
              {skillSet.map((item, id) => {
                return (
                  <a
                    href={item.text}
                    key={id}
                    whilehover={{ scale: 1.05 }}
                    whiletap={{ scale: 0.9 }}
                    className={`viewSite gradient-${gradientState}`}
                  >
                    {item.text}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
